"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylableChangeSelectors = exports.PartialChangeActionTarget = exports.PartialChangeActionType = void 0;
var callback_utils_1 = require("./utils/callback-utils");
var PartialChangeActionType;
(function (PartialChangeActionType) {
    PartialChangeActionType["MODIFY"] = "modify";
    PartialChangeActionType["ADD"] = "add";
    PartialChangeActionType["REMOVE"] = "remove";
})(PartialChangeActionType = exports.PartialChangeActionType || (exports.PartialChangeActionType = {}));
var PartialChangeActionTarget;
(function (PartialChangeActionTarget) {
    PartialChangeActionTarget["DECL"] = "decl";
    PartialChangeActionTarget["RULE"] = "rule";
})(PartialChangeActionTarget = exports.PartialChangeActionTarget || (exports.PartialChangeActionTarget = {}));
var warnOnceFlags = {
    applyDeprecated: false,
    modifyRule: false,
};
var DEFAULT_BLOCKING_ID = 'DEFAULT_BLOCKING_ID';
var StylableChangeSelectors = /** @class */ (function () {
    function StylableChangeSelectors(onQuickChange, onRevertQuickChange) {
        var _this = this;
        this.onQuickChange = onQuickChange;
        this.onRevertQuickChange = onRevertQuickChange;
        this.aggregatedQuickChanges = [];
        this.blocked = new Set();
        this.shouldCommitOnRelease = false;
        this.aggregatedPartialChanges = [];
        // TODO this can probably be removed everywhere (every revertRule)
        this.revertRule = function (_changeCallback) {
            _this.onRevertQuickChange && _this.onRevertQuickChange();
            _this.aggregatedQuickChanges = [];
        };
        this.startBlockingCommits = function (id) {
            if (id === void 0) { id = DEFAULT_BLOCKING_ID; }
            _this.blocked.add(id);
        };
        this.areSomeCommitsBlocked = function () {
            return !!_this.blocked.size;
        };
        this.releaseBlockingCommits = function (commitIfNeeded, id) {
            if (commitIfNeeded === void 0) { commitIfNeeded = true; }
            if (id === void 0) { id = DEFAULT_BLOCKING_ID; }
            _this.blocked.delete(id);
            if (!_this.areSomeCommitsBlocked()) {
                if (commitIfNeeded) {
                    if (_this.shouldCommitOnRelease) {
                        _this.commit();
                    }
                }
                else {
                    _this.shouldCommitOnRelease = false;
                }
            }
        };
        this.changeSelectors = function (changeRequest) {
            if (!_this.editSession) {
                return;
            }
            var _a = _this.editSession, stylableDriver = _a.stylableDriver, stylesheetPath = _a.stylesheetPath, sessionSelector = _a.selector;
            var sheet = stylableDriver.getStylesheet(stylesheetPath);
            if (!sheet) {
                return;
            }
            var changeActions = Array.isArray(changeRequest) ? changeRequest : [changeRequest];
            changeActions.forEach(function (changeAction) {
                var _a = changeAction.revertible, revertible = _a === void 0 ? false : _a, values = changeAction.values, _b = changeAction.selector, selector = _b === void 0 ? sessionSelector : _b;
                _this.callQuickChange(sheet, selector, values);
                // Add rule only if doesn't exist
                if (sheet.queryStyleRuleWithScopeFilter(selector).length === 0) {
                    _this.requestStylesheetChange([
                        {
                            stylesheetPath: stylesheetPath,
                            selector: selector,
                            action: { target: PartialChangeActionTarget.RULE, type: PartialChangeActionType.ADD },
                        },
                    ], true);
                }
                if (!revertible) {
                    _this.aggregatedQuickChanges.push(changeAction);
                }
            });
            if (!_this.areSomeCommitsBlocked()) {
                _this.commit();
            }
            else {
                _this.shouldCommitOnRelease = true;
            }
            _this.postChangeHook && _this.postChangeHook();
        };
    }
    StylableChangeSelectors.prototype.openSession = function (editSession) {
        this.editSession = editSession;
        this.aggregatedQuickChanges = [];
        this.shouldCommitOnRelease = false;
    };
    StylableChangeSelectors.prototype.setOnStylesheetCommit = function (onStylesheetCommit) {
        this.onStylesheetCommit = onStylesheetCommit;
    };
    StylableChangeSelectors.prototype.setPostCommitHook = function (postCommitHook) {
        this.postCommitHook = postCommitHook;
    };
    StylableChangeSelectors.prototype.setPostChangeHook = function (postChangeHook) {
        this.postChangeHook = postChangeHook;
    };
    StylableChangeSelectors.prototype.setOnPartialChange = function (partialChangeHook) {
        this.partialChangeHook = partialChangeHook;
    };
    StylableChangeSelectors.prototype.commit = function () {
        var _this = this;
        if (!this.editSession) {
            return;
        }
        var _a = this.editSession, stylableDriver = _a.stylableDriver, stylesheetPath = _a.stylesheetPath, sessionSelector = _a.selector;
        var sheet = stylableDriver.getStylesheet(stylesheetPath);
        if (sheet && this.aggregatedQuickChanges.length) {
            var valuesPerSelector_1 = this.getValuesPerSelector(sessionSelector);
            stylableDriver.batch(stylesheetPath, function () {
                Object.keys(valuesPerSelector_1).forEach(function (selector) {
                    _this.commitChangeToStylesheet(valuesPerSelector_1[selector], selector);
                });
            }, this.buildSingleAggregatedCallback());
            this.aggregatedQuickChanges = [];
        }
        this.shouldCommitOnRelease = false;
        this.postCommitHook && this.postCommitHook();
    };
    StylableChangeSelectors.prototype.commitChangeToStylesheet = function (values, selector) {
        if (!this.editSession) {
            return;
        }
        var _a = this.editSession, stylableDriver = _a.stylableDriver, stylesheetPath = _a.stylesheetPath;
        var sheet = stylableDriver.getStylesheet(stylesheetPath);
        if (!sheet) {
            return;
        }
        var props = Object.keys(values);
        var changes = [];
        if (props.length) {
            props.forEach(function (prop) {
                // Meant to move next upserted declaration to bottom
                changes.push({
                    stylesheetPath: stylesheetPath,
                    selector: selector,
                    action: { target: PartialChangeActionTarget.DECL, type: PartialChangeActionType.REMOVE },
                    declProp: prop,
                }, {
                    stylesheetPath: stylesheetPath,
                    selector: selector,
                    action: { target: PartialChangeActionTarget.DECL, type: PartialChangeActionType.MODIFY },
                    declProp: prop,
                    newValue: values[prop],
                });
            });
        }
        else {
            changes.push({
                stylesheetPath: stylesheetPath,
                selector: selector,
                action: { target: PartialChangeActionTarget.RULE, type: PartialChangeActionType.REMOVE },
            });
        }
        this.requestStylesheetChange(changes);
    };
    StylableChangeSelectors.prototype.callQuickChange = function (siteStylesheet, selector, values) {
        if (!this.onQuickChange || values === undefined) {
            return;
        }
        var evalValuesMap = Object.keys(values).reduce(function (currValuesMap, prop) {
            var newPropName = siteStylesheet.evalDeclarationProp(prop);
            currValuesMap[newPropName] = siteStylesheet.evalDeclarationValue(values[prop]);
            return currValuesMap;
        }, {});
        this.onQuickChange(selector, evalValuesMap);
    };
    StylableChangeSelectors.prototype.getValuesPerSelector = function (sessionSelector) {
        return this.aggregatedQuickChanges.reduce(function (valuesPerSelector, change) {
            var selector = change.selector || sessionSelector;
            if (change.values === undefined) {
                valuesPerSelector[selector] = {};
            }
            else {
                if (!valuesPerSelector[selector]) {
                    valuesPerSelector[selector] = {};
                }
                Object.assign(valuesPerSelector[selector], change.values);
            }
            return valuesPerSelector;
        }, {});
    };
    StylableChangeSelectors.prototype.buildSingleAggregatedCallback = function () {
        var callbacks = this.aggregatedQuickChanges
            .map(function (change) { return change.changeCallback; })
            .filter(function (cb) { return cb !== undefined; });
        var onStylesheetCommit = this.onStylesheetCommit;
        if (onStylesheetCommit) {
            callbacks.push(function () { return onStylesheetCommit(); });
        }
        return (0, callback_utils_1.uniteCallbacks)(callbacks);
    };
    StylableChangeSelectors.prototype.requestStylesheetChange = function (requestedChange, aggregate) {
        if (aggregate === void 0) { aggregate = false; }
        var preventDefault = false;
        if (requestedChange.length === 0) {
            return;
        }
        if (this.partialChangeHook) {
            this.aggregatedPartialChanges = this.aggregatedPartialChanges.concat(requestedChange);
            if (aggregate) {
                preventDefault = true;
            }
            else {
                var result = this.partialChangeHook(this.aggregatedPartialChanges);
                preventDefault = result;
                this.aggregatedPartialChanges = [];
            }
        }
        if (!preventDefault) {
            this.applyStylesheetChange(requestedChange);
        }
    };
    /**
     * deprecated: apply changes on their stylesheets
     * @param requestedChange - array of changes
     */
    StylableChangeSelectors.prototype.applyChangesToStylesheets = function (requestedChange) {
        if (!warnOnceFlags.applyDeprecated) {
            console.warn('"applyChangesToStylesheets" in stylable-change-selectors is deprecated, use "applyStylesheetChange" instead');
            warnOnceFlags.applyDeprecated = true;
        }
        this.applyStylesheetChange(requestedChange);
    };
    /**
     * apply changes on their stylesheets
     * @param requestedChange - array of changes
     */
    StylableChangeSelectors.prototype.applyStylesheetChange = function (requestedChange) {
        var _this = this;
        if (!this.editSession)
            return;
        var stylableDriver = this.editSession.stylableDriver;
        if (requestedChange.length === 0) {
            return;
        }
        var batchPaths = [];
        requestedChange.forEach(function (change) {
            batchPaths.push(change.stylesheetPath);
        });
        stylableDriver.batch(batchPaths, function () {
            requestedChange.forEach(function (change) {
                var stylesheetPath = change.stylesheetPath, selector = change.selector, action = change.action, declProp = change.declProp, newValue = change.newValue;
                var sheet = _this.editSession.stylableDriver.getStylesheet(stylesheetPath);
                if (!sheet)
                    return;
                switch (action.target) {
                    case PartialChangeActionTarget.DECL:
                        if (declProp) {
                            switch (action.type) {
                                case PartialChangeActionType.REMOVE:
                                    sheet.upsertDeclarationToRule(selector, { prop: declProp, value: undefined });
                                    break;
                                case PartialChangeActionType.ADD:
                                case PartialChangeActionType.MODIFY:
                                    sheet.upsertDeclarationToRule(selector, { prop: declProp, value: newValue });
                                    break;
                            }
                        }
                        else {
                            console.warn('applyStylesheetChange on a declaration should specify declProp, but it was undefined');
                        }
                        break;
                    case PartialChangeActionTarget.RULE:
                        switch (action.type) {
                            case PartialChangeActionType.REMOVE: {
                                var rules = sheet.getVariantStyleRules(selector);
                                rules.forEach(function (rule) { return sheet.removeRule(rule); });
                                break;
                            }
                            case PartialChangeActionType.ADD:
                                sheet.upsertStyleRule(selector, true);
                                break;
                            case PartialChangeActionType.MODIFY:
                                if (!warnOnceFlags.modifyRule) {
                                    console.warn('applyStylesheetChange does not currently support the action "MODIFY for target RULE". If you really really want this feature please contact the StylablePanel team');
                                    warnOnceFlags.modifyRule = true;
                                }
                                break;
                        }
                        break;
                }
            });
        });
    };
    return StylableChangeSelectors;
}());
exports.StylableChangeSelectors = StylableChangeSelectors;
//# sourceMappingURL=stylable-change-selectors.js.map